import axios, { type AxiosProgressEvent } from 'axios';

import {
	type EventItemsUploadResponse,
	eventItemsUploadResponseSchema,
} from '../models/item-upload';

/** @see AppleRetail.Web.Areas.StoreEvents.ApiControllers.StoreEventItemBulkImportApiController */
export async function uploadEventItemsTemplate(
	storeEventId: string,
	file: File,
	onUploadProgress?: (event: AxiosProgressEvent) => void,
): Promise<EventItemsUploadResponse> {
	const body = new FormData();
	body.append('file', file);
	body.append('RejectOnAnyError', 'true');

	const response = await axios.put<unknown>(`api/store-events/${storeEventId}/bulk/items`, body, {
		onUploadProgress,
	});

	return eventItemsUploadResponseSchema.parse(response.data);
}

export async function getErrorReportFileName(storeEventId: string, fileId: number) {
	const response = await axios.get<string>(
		`api/store-events/${storeEventId}/bulk/items/${fileId}`,
	);

	return response.data;
}

export async function completeEventItemsUpload(
	storeEventId: string,
	fileId: number,
): Promise<void> {
	await axios.post<unknown>(`api/store-events/${storeEventId}/bulk/items/${fileId}`, undefined, {
		headers: { Comment: 'N/A' },
	});

	return;
}

export function getEventItemsDownloadUrl(storeEventId: string) {
	return `/api/store-events/${storeEventId}/bulk/items`;
}

export function getErrorReportUrl(storeEventId: string) {
	return `/api/store-events/${storeEventId}/bulk/items/download-error-report`;
}

export function getExportItemsUrl(storeEventId: string) {
	return `/api/store-events/${storeEventId}/items/export`;
}
